import api from "../../../../../api";


export const requestGetPartOfferMessages = (props) => {

    let url = `/messages/from/part-offer`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetUserActiveRequestsMessages = (props) => {

    let url = `/messages/user/active-requests`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestGetUserOtherMessages = (props) => {

    let url = `/messages/user/other-messages`;

    const query = new URLSearchParams(props).toString();

    if (query) {
        url += "?" + query;
    };

    return api.get(url);
};

export const requestSendMessage = (payload) => {
    return api.post(`/messages`, payload);
};


